<template>
  <div>
    <button
        class="flex items-center justify-between text-medium-blue border-medium-blue font-bold border-2 py-2 px-4 rounded-l-full rounded-tr-full mx-auto"
        :class="[buttonStyle, { 'cursor-not-allowed' : disabled }]"
        :disabled="disabled">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"
           v-if="arrow === 'reverse'">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
      </svg>
      <slot></slot>
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"
           v-if="arrow === 'true'">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BubbleButton',
  props: {
    arrow: {
      type: String,
      default: "true"
    },
    type: '',
    disabled: Boolean
  },

  computed: {
    buttonStyle() {
      return this.disabled ? 'disabled' : this.type
    }
  }
}
</script>

<style lang="scss" scoped>
.inverted {
  @apply border-white text-white;
}

.plain {
  @apply bg-white border-white text-dark-blue;
}

.inverted-plain {
  @apply border-dark-blue bg-dark-blue text-white;
}

.disabled {
  @apply border-gray-500 text-gray-500;
}

</style>
